import React, { MutableRefObject } from "react"
import { MachinesContextType } from "../../../../_common/machines/machines-context"
import { CruiseSuiteCardButtonProps } from "../../../../../components/CruiseSuiteCard/CruiseSuiteCardButton"
import { ChooseButton } from "../../../../../components/CruiseSuiteCard/ChooseButton"

export const StandardCardButton = (
    machinesContextRef: MutableRefObject<MachinesContextType | undefined>,
): React.FC<Pick<CruiseSuiteCardButtonProps, "selected" | "suiteCategory">> =>
    function StandardCardButton({ suiteCategory, selected }) {
        const onSelect = (event: React.MouseEvent) => {
            event.preventDefault()
            machinesContextRef.current?.ecommerce.send({ type: "SELECT_SUITE_CATEGORY", suiteCategory })
        }
        return <ChooseButton selected={selected} onSelect={onSelect} />
    }
